import { useState } from 'react'
import { Typography } from '@mui/material';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { useZoneviseApartment } from '../../assets/api/useMarketingExecutive';
import { useDialog } from '../../shared/hook/useDialog';
import CustomDivider from '../../shared/utils/CustomDivider';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { useUserUnderManagerList } from '../../assets/api/useMarketingManager';
import useAuthStore from '../../store/useAuthStore';

const MarketingExecutiveTable = () => {
    const { user } = useAuthStore()
    const { data: userList, isLoading } = useUserUnderManagerList({ main_user_id: user?.id })

    const reportingUserOption = userList?.map((item, index) => ({
        id: item?.id,
        value: item?.firstname,
        label: item?.firstname,
        sr_no: index + 1,
        ...item
    })) || [];

    const { open, handleClickOpen, handleClose } = useDialog();

    const [selectedRow, setSelectedRow] = useState({});

    const { data: ApartmentList, isLoading: isApartmentLaoding } = useZoneviseApartment({ user_id: selectedRow.id })

    const ApartmentRows = ApartmentList?.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        ...item
    })) || [];

    const marketingExeColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "First Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "lastname",
            headerName: "Last Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "username",
            headerName: "User Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "reporting_to_firstname",
            headerName: "Reporting To",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value} {""} {params.row.reporting_to_lastname}</Typography>,
        },

    ];


    const handleViewApartment = (row) => {
        setSelectedRow(row)
        handleClickOpen()
    };

    const apartmentColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },


    ];

    return (
        <>

            <TableFilterTemplate
                title="Reporting User"
                columns={marketingExeColumns}
                rowsData={reportingUserOption || []}
                isLoading={isLoading}
                dataGridProps={{
                    onRowClick: (params) => handleViewApartment(params.row)
                }}
            />

            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>

                <TableFilterTemplate
                    title={`Apartment List for ${selectedRow.firstname} ${selectedRow.lastname}`}
                    columns={apartmentColumns}
                    rowsData={ApartmentRows || []}
                    isLoading={isApartmentLaoding}
                   pageSize={5}

                />
                <CustomDivider />

            </MainDialogBox>


        </>
    )
}

export default MarketingExecutiveTable 